import { createBrowserHistory } from 'history';

const { pathname } = window.location;
const slug = pathname.split('/')[2];

export const history = createBrowserHistory({
  basename: `/r/${slug}/`,
});
